
export default {
    name: 'FilterSelectionMobile',
    props: {
        actualValue: {
            type: Boolean,
            required: true,
            default: true
        },
        filterTitle: {
            type: String,
            required: true,
            default: ''
        }
    },
    data() {
        return {
            tmpValue: this.actualValue,
        }
    },
    watch: {
        actualValue(newValue) {
            this.tmpValue = newValue
        }
    },
    methods: {
        onClick() {
            this.$emit('update:actualValue', this.tmpValue)
            // window.scrollTo(0, 0);
        }
    }
}
